import { render, staticRenderFns } from "./SupplyRuleWidgetTable.vue?vue&type=template&id=3d6078e4"
import script from "./SupplyRuleWidgetTable.vue?vue&type=script&lang=js"
export * from "./SupplyRuleWidgetTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports